import { useState } from 'react';
import './Contact.css';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);

  const whatsappNumber = '+255718665620'; // WhatsApp number

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();

    const text = `📩 New Travel Inquiry
-------------------------
👤 Name: ${form.name}
📧 Email: ${form.email}
📱 Phone: ${form.phone}
📝 Subject: ${form.subject}
💬 Message: ${form.message}
-------------------------
Sent via Muhammed Tours Contact Form`;

    const sanitizedNumber = whatsappNumber.replace(/\D/g, '');
    const url = `https://wa.me/${sanitizedNumber}?text=${encodeURIComponent(text)}`;

    window.open(url, '_blank');

    setSent(true);
    setForm({ name: '', email: '', phone: '', subject: '', message: '' });
  };

  return (
    <section className="section contact-section">
      <h2>Contact Us</h2>
      <p className="muted">
        Share your travel dates, interests, and group size — our team will design a seamless journey for you.
      </p>

      {sent && (
        <div className="alert success">
          ✅ Your inquiry has been opened in WhatsApp. Please send it to reach us directly!
        </div>
      )}

      <form className="form contact-form" onSubmit={onSubmit}>
        <div className="form-group">
          <label htmlFor="name">Full Name *</label>
          <input id="name" name="name" value={form.name} onChange={onChange} required />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email Address *</label>
          <input id="email" type="email" name="email" value={form.email} onChange={onChange} required />
        </div>

        <div className="form-group">
          <label htmlFor="phone">Phone Number</label>
          <input id="phone" name="phone" value={form.phone} onChange={onChange} />
        </div>

        <div className="form-group">
          <label htmlFor="subject">Subject</label>
          <input id="subject" name="subject" value={form.subject} onChange={onChange} />
        </div>

        <div className="form-group">
          <label htmlFor="message">Message *</label>
          <textarea id="message" name="message" value={form.message} onChange={onChange} rows="6" required />
        </div>

        <div className="form-actions">
          <button className="btn whatsapp-btn" type="submit">
            📲 Send Inquiry via WhatsApp
          </button>
        </div>
      </form>

      <div className="contact-details">
        <h3>Our Contact Details</h3>
        <p><strong>Phone & WhatsApp:</strong> +255 718 665 620</p>
        <p><strong>Email:</strong> muhammedsalum625@gmail.com</p>
        <p><strong>Address:</strong> Unguja, Zanzibar, Tanzania</p>
      </div>
    </section>
  );
}
